import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Form, SelectPicker } from 'rsuite'

export default function BudgetApprovalReportForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    console.log('schemaschema ', schema)
    if (!clearValue) {
    }
  }, [clearValue])

  const Styles = {
    labelStyle: {
      marginTop: '5px',
      padding: '8px',
      textAlign: 'right',
    },
    inputStyle: {
      marginTop: '5px',
      padding: '8px',
    },
  }

  return (
    <>
      <Form id="mainContainer">
        {schema?.budgetYear && (
          <Row>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
              {schema.budgetYear.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
              <Controller
                name={schema.budgetYear.name}
                control={control}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={schema.budgetYear.options}
                      value={props.value}
                      block
                      placeholder={`เลือก${schema.budgetYear.label}`}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}></Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}></Col>
          </Row>
        )}
      </Form>
    </>
  )
}
